import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ec9691e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "faq",
  id: "FAQ"
}
const _hoisted_2 = { class: "faq__wrap-title" }
const _hoisted_3 = { class: "faq__blocks" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "faq__block-title" }
const _hoisted_6 = { class: "faq__block-toggle-icon-wrap" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "faq__block-toggle-icon-carpet" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 1,
  class: "faq__block-content-text"
}

import { ref } from 'vue';
import SectionTitle from "@/components/SectionTitle.vue";
import SleepAndRest from "@/components/faq/SleepAndRest.vue";
import Location from './faq/Location.vue';

type Block = {
  title: string;
  toggleBgColor: string;
  contentBgColor: string;
  text?: string;
  blockHeight: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FAQ',
  setup(__props) {

const openBlocks = ref(['']);

const toggleBlock = (blockTitle: string) => {
  if (openBlocks.value.includes(blockTitle)) {
    openBlocks.value = openBlocks.value.filter(title => title !== blockTitle)
  } else {
    openBlocks.value.push(blockTitle)
  }
}

const getBlockContentStyle = (block: Block) => ({background: block.contentBgColor, transform: openBlocks.value.includes(block.title) ? 'scaleY(1)' : 'scaleY(0)', maxHeight: openBlocks.value.includes(block.title) ? '2300px' : '0', marginBottom: openBlocks.value.includes(block.title) ? '10px' : '-120px'})


const blocks = [
  {
    title: 'what to expect on-site',
    toggleBgColor: '#01ffe5',
    contentBgColor: '#9efff5',
    blockName: 'expectation',
    html:
        '<p> The event is primarily a hackathon BUT since the venue enables us to also host talks, we would be crazy not to have those! </p> ' +
        '<p> Not only there are going to be various types of workspaces available, but also there is going to be:  </p> ' +
        '<ul> ' +
        '<li> 1 track of informative Solarpunk related and technical talks </li>' +
        '<li> 1 track of hands-on workshops </li>' +
        '</ul>' +
        '<p> Also, we have cookies! There is going to be free all-day catering provided for all participants!</p>',
    blockHeight: '300px'
  },
   {
    title: 'location',
    toggleBgColor: '#81ff70',
    contentBgColor: '#c1feb8',
    blockName: 'location',
    // html: 'location',
    //     '<div style="text-align: center"> ' +
    //     '<h3> Paralelni Polis & LaFabrika</h3>' +
    //     '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2559.088196893983!2d14.448352415899075!3d50.10335612019434!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470b94b187dd27cd%3A0x87ff46ed44b1086f!2sD%C4%9Blnick%C3%A1%2043%2C%20170%2000%20Praha%207-Hole%C5%A1ovice!5e0!3m2!1sen!2scz!4v1649344922786!5m2!1sen!2scz" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>' +
    //     '</div>',
    blockHeight: '450px'
  },
  {
    title: 'sleep & rest',
    blockName: 'sleepAndRest',

    toggleBgColor: '#ffff01',
    contentBgColor: '#ffffb2',
    // html: SleepAndRest,
    blockHeight: '2000px'
  },
  
  
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SectionTitle, { title: "FAQ about venue" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(blocks, (block) => {
        return _createElementVNode("div", {
          key: block.title,
          class: "faq__block"
        }, [
          _createElementVNode("div", {
            class: "faq__block-toggle",
            style: _normalizeStyle({background: block.toggleBgColor}),
            onClick: ($event: any) => (toggleBlock(block.title))
          }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(block.title), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: _normalizeClass(['faq__block-toggle-icon', {'faq__block-toggle-icon--upside-down': openBlocks.value.includes(block.title)}])
              }, _hoisted_8, 2)
            ])
          ], 12, _hoisted_4),
          _createElementVNode("div", {
            class: "faq__block-content-container",
            style: _normalizeStyle(getBlockContentStyle(block))
          }, [
            (block.blockName === 'expectation')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  innerHTML: block.html,
                  class: "faq__block-content-text"
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true),
            (block.blockName === 'location')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(Location)
                ]))
              : _createCommentVNode("", true),
            (block.blockName === 'sleepAndRest')
              ? (_openBlock(), _createBlock(SleepAndRest, {
                  key: 2,
                  class: "faq__block-content-text"
                }))
              : _createCommentVNode("", true)
          ], 4)
        ])
      }), 64))
    ])
  ]))
}
}

})